import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { DashboardService } from "../../../services";
import config from "config";

const TotalsAndHelpArea = ({ availableLocations, onError }) => {
  const [totalLocationsCount, setTotalLocationsCount] = useState(null);
  const [criticalEventLocationsCount, setCriticalEventLocationsCount] = useState(null);
  const [locationsOfflineCount, setLocationsOfflineCount] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setTotalLocationsCount(
      availableLocations != null ? availableLocations.length : 0
    );

    const requests = [
      DashboardService.getReportOrDashboardDataByToken(
        "critical_event_locations_count"
      ),
      DashboardService.getReportOrDashboardDataByToken(
        "locations_offline_count"
      ),
    ];

    Promise.all(requests)
      .then((results) => {
        results.forEach(({ token, reportResult }) => {
          if (token === "critical_event_locations_count") {
            setCriticalEventLocationsCount(
              reportResult && reportResult.count ? reportResult.count : 0
            );
          }
          if (token === "locations_offline_count") {
            const offlineLocations = reportResult && reportResult.filter((countData) => countData["device_count"] == countData["offline_count"]);
            setLocationsOfflineCount(offlineLocations && offlineLocations.length ? offlineLocations.length : 0);
          }
        });
      })
      .catch((error) => {
        console.error(error);
        setHasError(true);
        onError(error);
      });
  }, [availableLocations]);

  return totalLocationsCount != null && criticalEventLocationsCount != null && locationsOfflineCount != null ? (
    <div className="row">
      <div className="col-sm-12">
        <div className="needs-attention-dashboard-panels">
          <div className="na-dash-totals-container">
            <div className="na-dash-gt">
              <span>{totalLocationsCount}</span>
              {i18next.t("pages.locations-needing-attention.tools.total")}
            </div>

            <div className="na-dash-critical">
              <span>{criticalEventLocationsCount}</span>
              {i18next.t("pages.locations-needing-attention.tools.critical")}
            </div>

            <div className="na-dash-offline">
              <span>{locationsOfflineCount}</span>
              {i18next.t("pages.locations-needing-attention.tools.offline")}
            </div>
          </div>
          <div className="na-dash-static-container">
            <div className="na-dash-static-left">
              <div>
                <img
                  src={`${config.WEB_BASE_URL}/images/icon/static-help-icon.svg`}
                  className="icon icon--medium"
                />
                {i18next.t("pages.locations-needing-attention.tools.need-help")}
              </div>

              <p>
                {i18next.t(
                  "pages.locations-needing-attention.tools.knowledgebase-teaser"
                )}
              </p>
            </div>

            <div className="na-dash-static-right">
              <a href="//helpme.opsense.com/" className="btn btn-static">
                {i18next.t("pages.locations-needing-attention.tools.get-help")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : hasError ? null : (
    <div className="loader">
      {i18next.t("pages.locations-needing-attention.tools.loading")}
    </div>
  );
};

export default TotalsAndHelpArea;
